import Avatar from "@atlaskit/avatar";
import type {ComponentProps} from "react";

export function AnankeAvatar(props: ComponentProps<typeof Avatar>) {
    return <Avatar {...props} />;
}
